import React from 'react'
import { CheckIcon } from '@heroicons/react/solid'
import { colors } from '../../propsType/Colors'
const steps = [
  { id: '01', name: 'Moneda', href: '#', status: '' },
  { id: '02', name: 'Monto', href: '#', status: '' },
  { id: '03', name: 'Medios de Pago', href: '#', status: '' },
  { id: '04', name: 'Pagar', href: '#', status: '' },
  { id: '05', name: 'Confirmación', href: '#', status: '' },
]
function StepsGeneric({ stateSteps }) {
  return (
    <div>
      <nav aria-label="Progress">
        <ol role="list" className="border border-gray-300 rounded-md divide-y divide-gray-300 md:flex md:divide-y-0">
          {steps.map((step, stepIdx) => (
            <li key={step.name} className="relative md:flex-1 md:flex">
              {(
                step.id === '01' && !stateSteps.option1) ||
                (step.id === '02' && !stateSteps.option2 && !stateSteps.option1) ||
                (step.id === '03' && !stateSteps.option3 && !stateSteps.option2 && !stateSteps.option1) ||
                (step.id === '04' && !stateSteps.option4 && !stateSteps.option3 && !stateSteps.option2 && !stateSteps.option1) ||
                (step.id === '05' && !stateSteps.option5 && !stateSteps.option4 && !stateSteps.option3 && !stateSteps.option2 && !stateSteps.option1)
                ? (
                  <div className="group flex items-center w-full">
                    <span className="px-6 py-4 flex items-center text-sm font-medium">
                      <span className={`flex-shrink-0 w-10 h-10 flex items-center justify-center bg-[#5AB9E5] rounded-full`} >
                        <CheckIcon className="w-6 h-6 text-white" aria-hidden="true" />
                      </span>
                      <span className="ml-4 text-[17px] font-medium text-gray-900">{step.name}</span>
                    </span>
                  </div>
                ) : (
                  step.id === '01' && stateSteps.option1) ||
                  (step.id === '02' && stateSteps.option2 && !stateSteps.option1) ||
                  (step.id === '03' && !stateSteps.option4 && stateSteps.option3 && !stateSteps.option2 && !stateSteps.option1) ||
                  (step.id === '04' && stateSteps.option4 && !stateSteps.option3 && !stateSteps.option2 && !stateSteps.option1) ||
                  (step.id === '05' && stateSteps.option5 && !stateSteps.option4 && !stateSteps.option3 && !stateSteps.option2 && !stateSteps.option1) ? (
                  <div className="px-6 py-4 flex items-center text-sm font-medium" aria-current="step">
                    <span className={`flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-[${colors.lightBlue}] rounded-full `}>
                      <span className={`text-[${colors.lightBlue}]`} >{step.id}</span>
                    </span>
                    <span className={`ml-4 text-[17px]  whitespace-nowrap font-medium text-[${colors.lightBlue}]`}>{step.name}</span>
                  </div>
                ) : (
                  <div className="group flex items-center">
                    <span className="px-6 py-4 flex items-center text-sm font-medium">
                      <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full ">
                        <span className="text-gray-500 group-hover:text-gray-900">{step.id}</span>
                      </span>
                      <span className="ml-4 text-[17px]  whitespace-nowrap font-medium text-gray-500 group-hover:text-gray-900">{step.name}</span>
                    </span>
                  </div>
                )}

              {stepIdx !== steps.length - 1 ? (
                <>
                  <div className="hidden md:block absolute top-0 right-0 h-full w-5" aria-hidden="true">
                    <svg
                      className="h-full w-full text-gray-300"
                      viewBox="0 0 22 80"
                      fill="none"
                      preserveAspectRatio="none"
                    >
                      <path
                        d="M0 -2L20 40L0 82"
                        vectorEffect="non-scaling-stroke"
                        stroke="currentcolor"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </>
              ) : null}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  )
}

export default StepsGeneric